import { FunctionalComponent } from 'interfaces/components';

interface IContainerProps extends FunctionalComponent {
  className?: string;
  containerClassName?: string;
  isHome?: boolean;
  isResultsPage?: boolean;
  id?: string;
}

const Container: React.FC<IContainerProps> = ({
  children,
  className,
  containerClassName,
  isResultsPage,
  isHome = false,
  id,
  ...props
}) => {
  return (
    <div id={id} className={`w-full ${containerClassName}`}>
      <div
        className={`${
          isResultsPage ? 'px-5 md:px-0' : 'px-5 lg:px-4'
        } 2xl:px-0 max-w-[48rem] lg:max-w-[72.5rem] mx-auto ${className}`}
        {...props}>
        {children}
      </div>
    </div>
  );
};

export default Container;
